import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { FEATURES, FEATURES_FAILED, FEATURES_SUCCESS, LOGIN, LOGIN_FAILED, LOGIN_SUCCESS, MODULES, MODULES_FAILED, MODULES_SUCCESS, PERMISSIONS, PERMISSIONS_FAILED, PERMISSIONS_SUCCESS, REFERSH_TOKEN_FAILED, REFRESH_TOKEN, REFRESH_TOKEN_SUCCESS, UPDATE_USER } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"
import DefaultUser from "../../Assets/DefaultUser"
import { UPDATE_USERS_FAILED, UPDATE_USERS_SUCCESS } from "../Users/actionTypes"

export const handleLogin = (email, password) => async dispatch => {
  dispatch({
    type: LOGIN
  })
  try {
    const UserLogin = DefaultUser?.find((item) => item.email == email)
    console.log(UserLogin, "logindata");

    let response

    if (UserLogin) {
      response = { data: UserLogin };
    } else {
      response = await api(`auth/login`, 'post', { email, password });
    }
    localStorage.setItem('user', JSON.stringify(response?.data))

    let url = `users/usersList`;
    const queryParams = [];
    queryParams.push(`module=loginData`);
    queryParams.push(`id=${response?.data?.id}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    const userData = await api(url, "get", {}, getAuthHeader());
    if (userData.data?.[0].employee_type === 'Ex-Employee') {
      toast.error('Ex-Employee cannot login.');
      return dispatch({
        type: LOGIN_FAILED,
        payload: 'Ex-Employee cannot login.'
      })
    }

    const { profile_pic, ...restUser } = userData?.data?.[0];
    const combinedUser = {
      ...response.data,
      ...restUser
    };

    localStorage.setItem("user", JSON.stringify(combinedUser))

    if (profile_pic) {
      localStorage.setItem("userProfilePic", (profile_pic?.data || profile_pic));
    }

    dispatch({
      type: LOGIN_SUCCESS,
      payload: combinedUser
    })
    return combinedUser?.role?.name
  } catch (e) {
    console.log(e)
    toast.error("Login failed!")
    return dispatch({
      type: LOGIN_FAILED,
      payload: e?.message
    })
  }
}

export const refreshToken = (refresh_token) => async dispatch => {
  dispatch({
    type: REFRESH_TOKEN
  })
  try {
    let response = await api('auth/refreshtoken', 'post', { refresh_token })
    if (!response.status === 200) {
      dispatch({
        type: REFERSH_TOKEN_FAILED,
        payload: response.data
      })
      return response
    }
    dispatch({
      type: REFRESH_TOKEN_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (e) {
    return dispatch({
      type: REFERSH_TOKEN_FAILED,
      payload: e?.message
    })
  }
}


export const getFeatures = () => async (dispatch) => {
  dispatch({
    type: FEATURES,
  });
  try {
    let response = await api(`features/featuresList`, "get", {}, getAuthHeader());
    dispatch({
      type: FEATURES_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Features list error ====>", error);
    return dispatch({
      type: FEATURES_FAILED,
      payload: error?.message,
    });
  }
};

export const getModules = () => async (dispatch) => {
  dispatch({
    type: MODULES,
  });
  console.log("call module")
  try {
    let response = await api(`modules/modulesList`, "get", {}, getAuthHeader());
    dispatch({
      type: MODULES_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Modules list error ====>", error);
    return dispatch({
      type: MODULES_FAILED,
      payload: error?.message,
    });
  }
};

export const getPermissions = (id) => async (dispatch) => {
  dispatch({
    type: PERMISSIONS,
  });
  try {
    let response = await api(`auth/permissionsList/${id}`, "get", {}, getAuthHeader());
    const permissions = response?.data;
    dispatch({
      type: PERMISSIONS_SUCCESS,
      payload: response?.data,
    });
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user.role) {
        user.role.permissions_role = permissions;
        localStorage.setItem('user', JSON.stringify(user));
      }
    }
    return response;
  } catch (error) {
    console.log("while fetching permissions list error ====>", error);
    return dispatch({
      type: PERMISSIONS_FAILED,
      payload: error?.message,
    });
  }
};